import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBbDTFB_ObleqyWgx28cHfeL8CNN-nzwLo",
  authDomain: "password-manager-bc200.firebaseapp.com",
  projectId: "password-manager-bc200",
  storageBucket: "password-manager-bc200.appspot.com",
  messagingSenderId: "154880610910",
  appId: "1:154880610910:web:22113183ad0fee47b41acf",
  measurementId: "G-6708TV0Y4B"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

let analytics = null;
isSupported()
  .then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  })
  .catch(() => {
    analytics = null;
  });

export { app, auth, db, analytics };